import { CONSENT } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const consentScenarios: FakePageData = {
  url: CONSENT,
  items: {
    'Accept consents': [
      // first checkbox + modal scroll + accept modal btn
      ['[data-test="agreement-consents-checkbox-content"]', 'button'],
      ['[data-test="legal-modal-scrollable-content"]', 'scroll-to-bottom'],
      ['[data-test="modal-button"]', 'button'],
      // second checkbox + modal scroll + accept modal btn
      ['[data-test="agreement-legal-checkbox-content"]', 'button'],
      ['[data-test="agreement-modal-scrollable-content"]', 'scroll-to-bottom'],
      ['[data-test="modal-button"]', 'button'],
      // submit page
      ['[data-test="submit_btn_agreement"]', 'submit-button'],
    ],
  },
};

export { consentScenarios };
